// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { RasterUserSuppliedMeta } from "./RasterUserSuppliedMeta";
import {
  instanceOfRasterUserSuppliedMeta,
  RasterUserSuppliedMetaFromJSON,
  RasterUserSuppliedMetaFromJSONTyped,
  RasterUserSuppliedMetaToJSON,
} from "./RasterUserSuppliedMeta";
import type { SchematisationUserSuppliedMeta } from "./SchematisationUserSuppliedMeta";
import {
  instanceOfSchematisationUserSuppliedMeta,
  SchematisationUserSuppliedMetaFromJSON,
  SchematisationUserSuppliedMetaFromJSONTyped,
  SchematisationUserSuppliedMetaToJSON,
} from "./SchematisationUserSuppliedMeta";
import type { VectorUserSuppliedMeta } from "./VectorUserSuppliedMeta";
import {
  instanceOfVectorUserSuppliedMeta,
  VectorUserSuppliedMetaFromJSON,
  VectorUserSuppliedMetaFromJSONTyped,
  VectorUserSuppliedMetaToJSON,
} from "./VectorUserSuppliedMeta";

/**
 * @type Values
 *
 * @export
 */
export type Values =
  | RasterUserSuppliedMeta
  | SchematisationUserSuppliedMeta
  | VectorUserSuppliedMeta;

export function ValuesFromJSON(json: any): Values {
  return ValuesFromJSONTyped(json, false);
}

export function ValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Values {
  if (json == null) {
    return json;
  }
  if (typeof json !== "object") {
    return json;
  }
  if (instanceOfRasterUserSuppliedMeta(json)) {
    return RasterUserSuppliedMetaFromJSONTyped(json, true);
  }
  if (instanceOfSchematisationUserSuppliedMeta(json)) {
    return SchematisationUserSuppliedMetaFromJSONTyped(json, true);
  }
  if (instanceOfVectorUserSuppliedMeta(json)) {
    return VectorUserSuppliedMetaFromJSONTyped(json, true);
  }
  return {} as any;
}

export function ValuesToJSON(json: any): any {
  return ValuesToJSONTyped(json, false);
}

export function ValuesToJSONTyped(
  value?: Values | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  if (typeof value !== "object") {
    return value;
  }
  if (instanceOfRasterUserSuppliedMeta(value)) {
    return RasterUserSuppliedMetaToJSON(value as RasterUserSuppliedMeta);
  }
  if (instanceOfSchematisationUserSuppliedMeta(value)) {
    return SchematisationUserSuppliedMetaToJSON(value as SchematisationUserSuppliedMeta);
  }
  if (instanceOfVectorUserSuppliedMeta(value)) {
    return VectorUserSuppliedMetaToJSON(value as VectorUserSuppliedMeta);
  }
  return {};
}
